export default function SubHeader({ label }) {
  return (
    <>
      <h5>{label}</h5>
    </>
  );
}
